import { ReactNode, createContext, useContext, useSyncExternalStore } from "react";

import { AudioStoreState } from "@/features/audio/services/audio-state.store";
import { TelephonyServices, telephonyServices } from "@/features/telephony/services/telephony-services.factory";
import { TelephonyStoreState } from "@/features/telephony/services/telephony-state.store";

const TelephonyContext = createContext<TelephonyServices>(telephonyServices);

export const TelephonyServicesProvider = ({
    children,
    services = telephonyServices,
}: {
    children: ReactNode;
    services?: TelephonyServices;
}) => {
    return <TelephonyContext.Provider value={services}>{children}</TelephonyContext.Provider>;
};

export const useTelephonyServices = (): TelephonyServices => {
    return useContext(TelephonyContext);
};

export const useTelephonyState = (): TelephonyStoreState => {
    const { telephonyStateStore } = useTelephonyServices();
    return useSyncExternalStore(
        telephonyStateStore.subscribe.bind(telephonyStateStore),
        telephonyStateStore.getState.bind(telephonyStateStore)
    );
};

export const useAudioState = (): AudioStoreState => {
    const { audioStateStore } = useTelephonyServices();
    return useSyncExternalStore(
        audioStateStore.subscribe.bind(audioStateStore),
        audioStateStore.getState.bind(audioStateStore)
    );
};
